// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { isUserLoggedIn } from "../../utility/Utils"
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 7
let getUserCall = false
const sorting = DefaultConfig().sorter
const DateConversion = DefaultConfig().DateConversion
const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
const apiCall = async (method, endpoint, data) => {
    // console.log(method, endpoint, data)
    const authAxios = DefaultConfig().authAxios
    if (method === 'get') {
        return await authAxios.get(endpoint)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return ''
                    } else if (status === 406) {
                        let setCookie = ''
                        if (errorresponse.headers) {
                            setCookie = errorresponse.headers?.['x-set-cookie']
                        }
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} setCookie={setCookie} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'post') {
        return await authAxios.post(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return ''
                    } else if (status === 406) {
                        let setCookie = ''
                        if (errorresponse.headers) {
                            setCookie = errorresponse.headers?.['x-set-cookie']
                        }
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} setCookie={setCookie} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'patch') {
        return await authAxios.patch(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return ''
                    } else if (status === 406) {
                        let setCookie = ''
                        if (errorresponse.headers) {
                            setCookie = errorresponse.headers?.['x-set-cookie']
                        }
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} setCookie={setCookie} status={"danger"} />))
                        return ''
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'delete') {
        return await authAxios.delete(endpoint)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return ''
                    } else if (status === 406) {
                        let setCookie = ''
                        if (errorresponse.headers) {
                            setCookie = errorresponse.headers?.['x-set-cookie']
                        }
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} setCookie={setCookie} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    }
}

const apiUpdateCall = async (method, endpoint, data, toasttype) => {
    // console.log(method, endpoint, data)
    const authAxios = DefaultConfig().authAxios
    if (method === 'post') {
        return await authAxios.post(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        if (toasttype === 'filesave') {
                            toast(t => (<ToastMessage t={t} message={"File Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'fileremove') {
                            toast(t => (<ToastMessage t={t} message={"File Removed Successfully"} status={"success"} />))
                        } else if (toasttype === 'comment' && data.name !== 'ERBNDA') {
                            toast(t => (<ToastMessage t={t} message={"Comment Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'Yes/No') {
                            //
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Workorder Updated Successfully"} status={"success"} />))
                        }
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return ''
                    } else if (status === 406) {
                        let setCookie = ''
                        if (errorresponse.headers) {
                            setCookie = errorresponse.headers?.['x-set-cookie']
                        }
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} setCookie={setCookie} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    }
}

// Get Categories
export const getWorkOrderTypesAndCategories = createAsyncThunk("appCommonReducers/getWorkOrderTypesAndCategories", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetWorkOrderTypesAndCategories
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Stages
export const getWorkorderStages = createAsyncThunk("appCommonReducers/getWorkorderStages", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetWorkorderStages
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Country and States
export const getCountryStates = createAsyncThunk("appCommonReducers/getCountryStates", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetCountryStates
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const countrys = []
        resultData.forEach((element) => {
            countrys.push({ value: element.countryCode, label: element.countryName, states: element.statesList })
        })
        return {
            data: countrys,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Company Details
export const getCompanyDetails = createAsyncThunk("appCommonReducers/getCompanyDetails", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetCompanyDetails
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const company = []
        resultData.forEach((element) => {
            company.push({ value: element.companyId, label: element.name })
        })
        return {
            data: company,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const getAllCompanies = createAsyncThunk("appCommonReducers/getAllCompanies", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetAllCompanies
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const company = []
        resultData.forEach((element) => {
            company.push({ value: element.agentId, label: `${element.name}- ${element.agentId}`, companyId: element.id, name: element.name })
        })
        return {
            data: company,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Customer Dashboard Workorders
export const getWorkorders = createAsyncThunk("appCommonReducers/getWorkorders", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetCustomerWorkorders
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Employee Dashboard WOrkorders based on pagination
export const getWorkordersByFilters = createAsyncThunk("appCommonReducers/getWorkordersByFilters", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.FilterWorkorders
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Employee Dashboard WOrkorders based on pagination
export const getVesselDashboard = createAsyncThunk("appCommonReducers/getVesselDashboard", async (woData) => {
    const method = 'post'
    const endpoint = `${woData.categoryId}/${woData.type}/${ApiUrls.GetVesselDashboard}`
    const data = woData.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.vesselDashboardData ? resultData.vesselDashboardData : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize ? resultData.pageSize : 10
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Create Workorder Validation Checking for exist or not
export const ValidateWorkorderCreation = createAsyncThunk("appCommonReducers/ValidateWorkorderCreation", async (obj) => {
    const method = 'get'
    const endpoint = `${obj.categoryId}/${obj.type}/${ApiUrls.ValidateWorkorderCreation}?companyId=${obj.companyId ? obj.companyId : 0}`
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Validate Client Checking for exist or not
export const GetValidateClient = createAsyncThunk("appCommonReducers/GetValidateClient", async (uniqueNo) => {
    const method = 'get'
    const endpoint = `${ApiUrls.ValidateClient}?uniqueNumber=${uniqueNo}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Company Details in salesforce
export const GetCompanyDetailsByName = createAsyncThunk("appCommonReducers/GetCompanyDetailsByName", async (name) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetPartiesByName}/${name}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetPartiesByName = createAsyncThunk("appCommonReducers/GetPartiesByName", async (name) => {
    if (isNaN(name)) {
        const method = 'get'
        const endpoint = `${ApiUrls.GetPartiesByName}/${name}`
        const data = ''
        const resultData = await apiCall(method, endpoint, data)
        return resultData
    } else {
        const method = 'get'
        const endpoint = `${ApiUrls.GetPartiesByPartyId}?partyId=${name}`
        const data = ''
        const resultData = await apiCall(method, endpoint, data)
        return resultData
    }
})

export const GetCorporationsByNameOrId = createAsyncThunk("appCommonReducers/GetCorporationsByNameOrId", async (name) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCorporationsByNameOrId}?value=${name}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetDashBoardData = createAsyncThunk("appCommonReducers/GetDashBoardData", async (name) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetDashBoardData}?value=${name}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

// Get Company Details in salesforce
export const GetPartiesOfCurrentUser = createAsyncThunk("appCommonReducers/GetPartiesOfCurrentUser", async () => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetPartiesOfCurrentUser}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const company = []
        resultData.forEach((element) => {
            company.push({ value: element.partyId, label: `${element.partyName} - ${element.partyId}`, name: element.partyName })
        })
        const trueBool = true
        return {
            data: company,
            spinner: true,
            tokenExp: false,
            unauthorize: company.length === 0 ? trueBool : false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false,
            unauthorize: false
        }
    }
})

export const RefreshWorkorderEntities = createAsyncThunk("appCommonReducers/RefreshWorkorderEntities", async (woData) => {
    const method = 'post'
    const endpoint = `${woData.ccode}/${woData.tcode}/${ApiUrls.RefreshWorkorderEntities}`
    const data = { workorderId: Number(woData.woId) }
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Create Company
export const CreateCompany = createAsyncThunk("appCommonReducers/CreateCompany", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.CreateCompany
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

// Get Preview Document
export const GetPreviewDocument = createAsyncThunk("appCommonReducers/GetPreviewDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetPreviewDocument}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Base Workorder Data
export const getBaseWorkorderData = createAsyncThunk("appCommonReducers/getBaseWorkorderData", async (wdata) => {
    if (wdata.value === 'ena') {
        const method = 'get'
        const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetBaseWorkOrderData}`
        const data = ''
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false
            }
        } else {
            return {
                data: null,
                spinner: true,
                tokenExp: false
            }
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const AgentWorkorderEntities = createAsyncThunk("appCommonReducers/AgentWorkorderEntities", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.AgentWorkorderEntities}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    }
})

// Get Get Template Workorder Data
export const getCorporationsByPartyId = createAsyncThunk("appCommonReducers/getCorporationsByPartyId", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCorporationsByPartyId}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    }
})

// Get Get Template Workorder Data
export const getCommonDashboardData = createAsyncThunk("appCommonReducers/getCommonDashboardData", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetDashBoardData}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            perPage: wdata.perPage,
            page: wdata.page,
            spinner: true,
            tokenExp: false,
            tab: wdata.tab
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            tab: wdata.tab
        }
    }
})

// Get Get Template Workorder Data
export const GetCorporationsByEntityIdOrName = createAsyncThunk("appCommonReducers/GetCorporationsByEntityIdOrName", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCorporationsByEntityIdOrName}?value=${wdata.entityValue}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            perPage: wdata.perPage,
            page: wdata.page,
            spinner: true,
            tokenExp: false,
            tab: wdata.tab
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            tab: wdata.tab
        }
    }
})

export const getData = createAsyncThunk("appCommonReducers/getData", async (wdata) => {
    return wdata
})

// Get Get Template Workorder Data
export const getDocumentTemplateData = createAsyncThunk("appCommonReducers/getDocumentTemplateData", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetDocumentTemplateData}?documentId=${wdata.documentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    }
})

// Get Get Template Workorder Data
export const getDocumentTemplateByCode = createAsyncThunk("appCommonReducers/getDocumentTemplateByCode", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetDocumentTemplateByCode}?code=${wdata.code}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    }
})

// Create workorder
export const CreateWorkorder = createAsyncThunk("appCommonReducers/CreateWorkorder", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.CreateWorkorder}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Workorder Data
export const getWorkordersData = createAsyncThunk("appCommonReducers/getWorkordersData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetWorkorderById}?id=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false,
            access: true
        }
    } else {
        return {
            access: false
        }
    }
})

// Update Workorder Json Data
export const updateWoData = createAsyncThunk("appCommonReducers/updateWoData", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorderData}?woId=${wdata.woData.id}`
    const data = wdata.woData
    const type = wdata.type
    const resultData = await apiUpdateCall(method, endpoint, data, type)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Workorder Data
export const UpdateWorkorder = createAsyncThunk("appCommonReducers/UpdateWorkorder", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorder}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update RequestMoreInfo Data
export const UpdateIsNeedMoreInfo = createAsyncThunk("appCommonReducers/UpdateIsNeedMoreInfo", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RequestMoreInfo}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update UpdateNeedMoreInfoStatus Data
export const UpdateNeedMoreInfoStatus = createAsyncThunk("appCommonReducers/UpdateNeedMoreInfoStatus", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNeedMoreInfoStatus}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Cancel Workorder
export const CancelWorkorder = createAsyncThunk("appCommonReducers/CancelWorkorder", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${(wdata.modalName === 'Cancel' || wdata.modalName === 'Delete') ? ApiUrls.CancelWorkorder : (wdata.modalName === 'Archive' ? ApiUrls.ArchivedWorkorder : ApiUrls.RejectWorkorder)}?companyId=${wdata.comId}&woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const resData = resultData
        resData.stage = (resultData.stage === 6 || resultData.stage === 12) ? 0 : resultData.stage
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Resend Docusign Email
export const ResendDocusignEmail = createAsyncThunk("appCommonReducers/ResendDocusignEmail", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendDocusignEmail}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Invoice Document
export const GetInvoiceDocument = createAsyncThunk("appCommonReducers/GetInvoiceDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get download file
export const DownloadFile = createAsyncThunk("appCommonReducers/DownloadFile", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.DownloadFile}?fileId=${wdata.fileId}&imoNumber=${wdata.imoNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Last Modified files
export const GetLastModifiedFiles = createAsyncThunk("appCommonReducers/GetLastModifiedFiles", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetLastModifiedFiles}?count=10`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Validate Client Checking for exist or not
export const GetCompanyAddress = createAsyncThunk("appCommonReducers/GetCompanyAddress", async (uniqueNo) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCompanyAddress}?uniqueNumber=${uniqueNo}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// start workorder omments
export const getWorkordersByIdComments = createAsyncThunk("appCommonReducers/getWorkordersByIdComments", async (woId) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkorderComments}?woId=${woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Billing Prefix Workorder
export const RegenerateAuthorizationLetter = createAsyncThunk("appCommonReducers/RegenerateAuthorizationLetter", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RegenerateAuthorizationLetter}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Document Regenerated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Authorization Document 
export const GetAuthorizationDocument = createAsyncThunk("appCommonReducers/GetAuthorizationDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAuthorizationDocument}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Create Workorder Comment
export const createWorkOrderComment = createAsyncThunk("appCommonReducers/createWorkOrderComment", async (obj) => {
    if (obj.status !== 'need') {
        const method = 'post'
        const endpoint = `${ApiUrls.CreateComment}`
        const data = obj
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false,
                needstatus: obj.status,
                needcomment: obj.comment
            }
        }
    } else {
        return {
            data: obj
        }
    }
})
// end workorder omments


// Update Billing Prefix Workorder
export const UpdateBillingPrefix = createAsyncThunk("appCommonReducers/UpdateBillingPrefix", async (wdata) => {
    const method = 'patch'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateBillingPrefix}?woId=${wdata.woId}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Billing Prefix Updated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Resend Email Workorder
export const UpdateResendEmail = createAsyncThunk("appCommonReducers/UpdateResendEmail", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateResendEmail}?woId=${wdata.woId}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Resend Email Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Billing Prefix Workorder
export const RegenarateAuthorizationLetter = createAsyncThunk("appCommonReducers/RegenarateAuthorizationLetter", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RegenarateAuthorizationLetter}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Document Regenerated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// get byte array format
export const getInvoiceFileData = createAsyncThunk("appCommonReducers/getInvoiceFileData", async (fileId) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkOrderFilesByFileId}?fileId=${fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getWorkordersById = createAsyncThunk("appCommonReducers/getWorkordersById", async (woId) => {
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`GetWorkOrderById/${woId}`)
        .then((response) => {
            const respData = response.data
            if (respData) {
                if (respData.success) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                } else {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: true,
                        tokenExp: false
                    }
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 403) {
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: true
                    }
                } else if (status === 401) {
                    localStorage.clear()
                    window.location.reload()
                } else {
                    // const error = errorresponse.data.error
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: false
                    }
                }
            }
        })
    return resultData
})

export const getNeedMoreInfoTracking = createAsyncThunk("appCommonReducers/getNeedMoreInfoTracking", async (woId) => {
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`NeedMoreInfoTracking/${woId}/${false}`)
        .then((response) => {
            const respData = response.data
            if (respData) {
                if (respData.success) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                } else {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: true,
                        tokenExp: false
                    }
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 403) {
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: true
                    }
                } else if (status === 401) {
                    localStorage.clear()
                    window.location.reload()
                } else {
                    // const error = errorresponse.data.error
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: false
                    }
                }
            }
        })
    return resultData
})

export const downloadPDF = createAsyncThunk("appCommonReducers/downloadPDF", async (data) => {
    const authAxios = DefaultConfig().authAxios
    const obj = data.woIdData
    let apiname = ''
    if (data.name === 'NDA') {
        apiname = 'GeneratePMSCNDAAgreement'
    } else if (data.name === 'MSA') {
        apiname = 'GeneratePMSCMSAAgreement'
    } else if (data.name === 'PAS') {
        apiname = 'GeneratePMSCPAAgreement'
    } else if (data.name === 'SOC') {
        apiname = 'GenerateSOCAgreement'
    }
    const resultData = await authAxios.post(`${apiname}`, obj)
        .then((response) => {
            const respData = response.data
            if (respData) {
                if (respData.success) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    } else {
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return {
                            data: [],
                            spinner: true,
                            tokenExp: false
                        }
                    }
                } else {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: true,
                        tokenExp: false
                    }
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 403) {
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: true
                    }
                } else if (status === 401) {
                    localStorage.clear()
                    window.location.reload()
                } else {
                    // const error = errorresponse.data.error
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: false
                    }
                }
            }
        })
    return resultData
})

export const getInvoiceData = createAsyncThunk("appCommonReducers/getInvoiceData", async (woId) => {
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`GetinvoiceDetailsByWOId/${woId}`)
        .then((response) => {
            const respData = response.data
            if (respData) {
                if (respData.success) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                } else {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: true,
                        tokenExp: false
                    }
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 403) {
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: true
                    }
                } else if (status === 401) {
                    localStorage.clear()
                    window.location.reload()
                } else {
                    // const error = errorresponse.data.error
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: false
                    }
                }
            }
        })
    return resultData
})

// Start File Upload, download and remove files
export const getUpdateFileData = createAsyncThunk("appCommonReducers/getUpdateFileData", async (newObj) => {
    return newObj
})

export const getFailedFileData = createAsyncThunk("appCommonReducers/getFailedFileData", async (newObj) => {
    return newObj
})

export const closeProgressModal = createAsyncThunk("appCommonReducers/closeProgressModal", async (value) => {
    return value
})

export const GetAllActiveVaultsForUser = createAsyncThunk("appCommonReducers/GetAllActiveVaultsForUser", async () => {
    const method = 'get'
    const endpoint = `User/${ApiUrls.GetAllActiveVaultsForUser}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
export const uploadCompleted = createAsyncThunk("appCommonReducers/uploadCompleted", async ({ blocksData, values }, thunkAPI) => {
    try {
        const authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: {
                "X-File-Name": values['filename'],
                "X-WO-ID": values['woId'],
                "X-DocumentType": values.fileDto[0].documentType,
                Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            withCredentials: true
        })
        const response = await authAxios.post(`FileUpload/CompleteUpload`, blocksData)
        const resData = response.data
        if (resData.success) {
            const newObj = {}
            newObj['floader'] = true
            newObj['tokenExp'] = false
            newObj['fileData'] = resData.data
            newObj['woType'] = values.fileDto[0].type
            newObj['woTypeId'] = values.woId
            newObj['stype'] = values.stype

            newObj['beginingOfTheChunk'] = 0
            newObj['endOfTheChunk'] = chunkSize
            newObj['blockData'] = []
            return newObj
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    } catch (error) {
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
})

export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
    if (values.fileDto.length > 0) {
        const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
        try {
            const authAxios = axios.create({
                baseURL: baseApiUrl,
                headers: {
                    "X-Total-Chunks": values['chunkCount'],
                    "X-Chunk-Number": values['counter'],
                    "X-File-Name": values['filename'],
                    "X-File-Size": values['fileSize'],
                    "X-Chunk-Size": values['chunkSize'],
                    "X-WO-ID": values['woId'],
                    "X-DocumentType": values.fileDto[0].documentType,
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
            })
            const response = await authAxios.post(`FileUpload/FileUploadChunks`, chunk)
            const respdata = response.data
            if (respdata.success) {
                if (values['counter'] === values['chunkCount']) {
                    const blocksData = values.blockData
                    blocksData.push(respdata.data)
                    const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
                    const uploadedData = respayload.payload
                    return uploadedData
                } else {
                    const blocksData = values.blockData
                    blocksData.push(respdata.data)
                    const beginingOfTheChunk = values['endOfTheChunk']
                    const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
                    const newObj = {}
                    newObj['beginingOfTheChunk'] = beginingOfTheChunk
                    newObj['endOfTheChunk'] = endOfTheChunk
                    newObj['blockData'] = blocksData
                    return newObj
                }
            } else {
                // console.log("Error Occurred:", data.errorMessage)
                thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                thunkAPI.dispatch(getFailedFileData({ filename: values['filename'], showFail: true }))
                return ''
            }
        } catch (error) {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            // console.log("error", error)
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
        }
    }
})

export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {
    if (values.fileDto.length > 0) {
        const _file = values.fileDto[0].file
        // console.log(_file.size, 1048576 * 1024)
        if (_file.size <= 1048576 * 1024) {
            const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            const fileSize = _file.size
            const filename = _file.name

            values['chunkSize'] = chunkSize
            values['_file'] = _file
            values['chunkCount'] = chunkCount
            values['fileSize'] = fileSize
            values['filename'] = filename

            values['beginingOfTheChunk'] = 0
            values['endOfTheChunk'] = chunkSize
            values['blockData'] = []

            for (let i = 0; i < chunkCount; i++) {
                values['counter'] = i + 1
                const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
                const fileUploadData = respayload.payload
                if ((i + 1) === chunkCount) {
                    if (fileUploadData) {
                        thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                        thunkAPI.dispatch(getFailedFileData({ filename: values['filename'], showFail: false }))
                        // console.log(fileUploadData)
                        return {
                            data: fileUploadData.fileData,
                            spinner: fileUploadData.floader,
                            tokenExp: fileUploadData.tokenExp,
                            woType: fileUploadData.woType,
                            woTypeId: fileUploadData.woTypeId,
                            stype: fileUploadData.stype,
                            type: values['type']
                        }
                    } else {
                        thunkAPI.dispatch(getFailedFileData({ filename: values['filename'], showFail: true }))
                        break
                    }
                } else {
                    if (fileUploadData) {
                        thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                        values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
                        values['endOfTheChunk'] = fileUploadData.endOfTheChunk
                        values['blockData'] = fileUploadData.blockData
                    } else {
                        break
                    }
                }
            }
        } else {
            toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
        }
    }
})

export const downloadChunk = createAsyncThunk("appCommonReducers/downloadChunk", async (values, thunkAPI) => {
    try {
        const authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: {
                "Content-Range": `bytes ${values.offset}-${values.end}/${values.totalSize}`,
                Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            withCredentials: true
        })
        const response = await authAxios.get(`FileUpload/GetFileContentByFileId?fileId=${values['fileId']}`)
        const resData = response.data
        if (resData.success) {
            const respData = resData.data
            return respData
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    } catch (error) {
        console.log("error", error)
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
})


const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
}

export const getWoFile = createAsyncThunk("appCommonReducers/getWoFile", async (fileId, thunkAPI) => {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`FileUpload/GetFilePropertiesByFileId?fileId=${fileId}`)
    // console.log(resultData)
    const resData = resultData.data
    if (resData) {
        if (resData.success) {
            const respData = resData.data
            if (respData) {
                const fileName = respData.fileName
                const contentType = respData.contentType
                const totalSize = Number(respData.contentLength)
                // const chunkSize = 1024 * 1024 * 1// 1MB chunk size
                const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
                const chunks = []
                let offset = 0
                let counter = 1
                // let count = 0
                // const concatenatedArray = new Uint8Array(totalSize)

                while (offset < totalSize) {
                    const end = Math.min(offset + chunkSize, totalSize) - 1
                    const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
                    const chunk = respayload.payload

                    // const binaryString = Buffer.from(chunk, 'base64').toString('binary')
                    // const chunkUint8Array = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)))
                    // concatenatedArray.set(chunkUint8Array, count * chunkSize)

                    chunks.push(chunk)
                    offset += chunkSize
                    if (counter === chunkCount) {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    } else {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    }
                    counter++
                    // count++
                }

                // // Combine base64 chunks into a single base64 string
                // const combinedBase64 = chunks.join('')
                // // Convert base64 string to binary data
                // const binaryData = atob(combinedBase64)
                // // Create array buffer from binary data
                // const arrayBuffer = new ArrayBuffer(binaryData.length)
                // const uint8Array = new Uint8Array(arrayBuffer)
                // for (let i = 0; i < binaryData.length; i++) {
                //   uint8Array[i] = binaryData.charCodeAt(i)
                // }

                const blobChunks = []
                // Fetch each chunk and push it to the array
                for (const chunk of chunks) {
                    const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
                    const blob = await response.blob()
                    blobChunks.push(blob)
                }

                // Convert the Uint8Array to a Blob
                const concatenatedBlob = new Blob(blobChunks, { type: contentType })
                // Generate download URL
                const downloadUrl = URL.createObjectURL(concatenatedBlob)

                // Initiate a download by creating an anchor element and programmatically clicking it
                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = fileName
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(downloadUrl)

                return {
                    data: { fileName, contentType, fileContent: '' },
                    tokenExp: false
                }
            }
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
    // return resultData
})

export const getWoAgreement = createAsyncThunk("appCommonReducers/getWoAgreement", async (wdata) => {
    const authAxios = DefaultConfig().authAxios
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAgreementDocument}?woId=${wdata.id}&corpCategory=${wdata.entityTypeVal}`
    const resultData = await authAxios.get(endpoint)
    const resData = resultData.data
    if (resData) {
        if (resData.success) {
            const respData = resData.data
            if (respData) {
                const fileName = respData.fileName
                const fileContent = respData.fileContent
                let fullFile = new Blob()
                fullFile = new Blob([fullFile, b64toBlob(fileContent)])
                // Generate download URL
                const downloadUrl = URL.createObjectURL(fullFile)

                // Initiate a download by creating an anchor element and programmatically clicking it
                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = fileName
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(downloadUrl)

                return {
                    data: { fileName, contentType: 'application/pdf', fileContent: '' },
                    tokenExp: false
                }
            }
        } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
    // return resultData
})

export const getWoPreview = createAsyncThunk("appCommonReducers/getWoPreview", async (wdata) => {
    const authAxios = DefaultConfig().authAxios
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.PreviewAgreementDocument}?woId=${wdata.id}&corpCategory=${wdata.entityTypeVal}`
    const resultData = await authAxios.get(endpoint)
    const resData = resultData.data
    if (resData) {
        if (resData.success) {
            const respData = resData.data
            if (respData) {
                if (respData.fileContent) {
                    const fileName = respData.fileName
                    if ((fileName.includes('.pdf') || fileName.includes('.PDF'))) {
                        // Convert base64 string to a Blob
                        const byteCharacters = atob(respData.fileContent)
                        const byteNumbers = new Array(byteCharacters.length)
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i)
                        }
                        const byteArray = new Uint8Array(byteNumbers)
                        const blob = new Blob([byteArray], { type: 'application/pdf' })

                        // Create a Blob URL
                        const blobUrl = URL.createObjectURL(blob)
                        // Open a new tab with the Blob URL
                        window.open(blobUrl, '_blank')
                    } else {
                        const linkSource = `data:${respData.contentType};base64,${respData.fileContent}`
                        const downloadLink = document.createElement("a")
                        const fileName = respData.fileName
                        downloadLink.href = linkSource
                        downloadLink.download = fileName
                        downloadLink.click()
                    }
                    return {
                        data: { fileName, contentType: 'application/pdf', fileContent: '' },
                        tokenExp: false
                    }
                }
            }
        } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
    // return resultData
})

export const saveMultipleFileUploads = createAsyncThunk("appCommonReducers/saveMultipleFileUploads", async (values) => {
    if (values.fileDto.length > 0) {
        const formData = new FormData()
        formData.append("file", values.fileDto[0].file)
        const authAxios = DefaultConfig().authAxios
        const resultData = await authAxios
            .patch(`MultipleFileUpload?wo_id=${values.woId}`, formData).then((response) => {
                const respData = response.data
                if (respData) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        return {
                            data: [],
                            spinner: false,
                            tokenExp: true
                        }
                    } else {
                        const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={error} status={"danger"} />))
                        return {
                            data: [],
                            spinner: false,
                            tokenExp: false
                        }
                    }
                }
            })
        return resultData
    }
})

export const removeWoFile = createAsyncThunk("appCommonReducers/removeWoFile", async (values) => {
    const method = 'delete'
    const endpoint = `${ApiUrls.RemoveWorkorderDocument}?woId=${values.woId}&fileId=${values.fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
// End File Upload, download and remove files

export const saveCSVRCWDocument = createAsyncThunk("appCommonReducers/saveCSVRCWDocument", async (wdata) => {
    const values = wdata.fileData
    if (values.fileDto.length > 0) {
        const formData = new FormData()
        formData.append("file", values.fileDto[0].file)
        const woType = values.fileDto[0].type
        const method = 'post'
        const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateVesselDetails}?woId=${values.woId}`
        const data = formData
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false,
                woType,
                woTypeId: values.woId,
                stype: values.stype,
                errorMsg: ''
            }
        }
    }
})

export const getVendorsSharePointList = createAsyncThunk("appCommonReducers/getVendorsSharePointList", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVendorsData}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getVesselOwnersSharePointList = createAsyncThunk("appCommonReducers/getVesselOwnersSharePointList", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselOwnersData}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getBillableVesselsForPreviousQuarter = createAsyncThunk("appCommonReducers/getBillableVesselsForPreviousQuarter", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetBillableVoyAges}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getERBPCListByIMONumber = createAsyncThunk("appCommonReducers/getERBPCListByIMONumber", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetERBPCListByIMONumber}?imoNumber=${wdata.imoNumber}&companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
export const getUpdatedBillableVoyAges = createAsyncThunk("appCommonReducers/getUpdatedBillableVoyAges", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetUpdatedBillableVoyages}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// IHM SOC API's
export const getIMONumbers = createAsyncThunk("appCommonReducers/getIMONumbers", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVesselsByAccountId}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const imos = []
        resultData.forEach((element) => {
            imos.push({ value: element.imoNumber, label: `${element.imoNumber} - ${element.nameofShip}`, disabled: element.isWorkorderExists })
        })
        return {
            data: imos,
            spinner: true,
            tokenExp: false
        }
    }
})
export const getRlmVessels = createAsyncThunk("appCommonReducers/getRlmVessels", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVesselsByAccountId}?companyId=${wdata.companyId ? wdata.companyId : 0}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const imos = []
        resultData.forEach((element) => {
            imos.push({
                value: element.imoNumber,
                label: element.imoNumber,
                imoNumber: element.imoNumber,
                isSameCompany: element.isSameCompany,
                isWorkorderExists: element.isWorkorderExists,
                vesselName: element.nameofShip,
                registrationDate: element.registrationDate
            })
        })
        return {
            data: imos,
            spinner: true,
            tokenExp: false
        }
    }
})
export const getListFiles = createAsyncThunk("appCommonReducers/getListFiles", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetListFiles}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
export const getVesselByImoNumber = createAsyncThunk("appCommonReducers/getVesselByImoNumber", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselByIMONumber}?imoNumber=${wdata.imoNumber}&companyId=${wdata.companyId ? wdata.companyId : 0}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const companys = []
        const billingParties = resultData.billingParties
        if (billingParties) {
            billingParties.forEach((element) => {
                companys.push({ value: element.id, label: `${element.name} - ${element.type}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode })
            })
        }
        return {
            data: resultData,
            companysData: companys,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ResendEmails = createAsyncThunk("appCommonReducers/ResendEmails", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendEmails}?woId=${wdata.woId}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCompanyAddressdetails = createAsyncThunk("appCommonReducers/GetCompanyAddressdetails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCompanyAddressdetails}?uniqueId=${wdata.uniqueId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetERBRAVersionChecking = createAsyncThunk("appCommonReducers/GetERBRAVersionChecking", async (payloadData) => {
    const method = 'get'
    const endpoint = `${payloadData.ccode}/${payloadData.tcode}/${ApiUrls.GetSoftwareVersionPClist}?companyId=${payloadData.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getAllProductCodes = createAsyncThunk("appCommonReducers/getAllProductCodes", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllProducts}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const productCodes = []
        resultData.forEach((element) => {
            productCodes.push({ code: element.productCode, name: element.description, id: element.id })
        })
        return {
            data: productCodes,
            spinner: true,
            tokenExp: false
        }
    }
})

export const CurrentQBbyCompany = createAsyncThunk("appCommonReducers/CurrentQBbyCompany", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCurrentQBbyCompany}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})


export const getStepNameStatus = createAsyncThunk("appCommonReducers/getStepNameStatus", async (name) => {
    return name
})

export const getClearStatus = createAsyncThunk("appCommonReducers/getClearStatus", async () => {
    return ''
})

export const getClearAppStatus = createAsyncThunk("appCommonReducers/getClearAppStatus", async () => {
    return ''
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
    return ''
})

export const getClearPaymentStatus = createAsyncThunk("appCommonReducers/getClearPaymentStatus", async () => {
    return ''
})

export const createWorkorder = createAsyncThunk("appCommonReducers/createWorkorder", async (boolean) => {
    return { boolean }
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
    return ''
})

export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
    return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
    return ''
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
    return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
    return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
    return ''
})

export const commonreducerSlice = createSlice({
    name: 'appCommonReducers',
    initialState: {
        woCates: [],
        spinner1: false,
        enableAction: false,

        woStages: [],
        spinner2: false,

        allData: [],
        data: [],
        totalCount: 1,
        cdSpinner: false,

        woData: [],
        spinner3: false,
        recCount: 0,
        gridSize: 0,

        cloader: false,
        countryStates: [],

        dloader: false,
        documentTypes: [],

        woIData: null,
        spinner4: false,

        needMoreTracking: false,

        woIdComments: [],
        spinnerComment: false,
        needstatus: '',
        needcomment: '',
        commentData: null,

        wloader: false,
        woIdData: null,
        invoiceFileId: null,
        autherizationFileId: null,
        pdfData: null,

        woIdDocs: [],
        wdloader: false,

        fileData: {},
        uploadErrMsg: '',
        woType: '',
        stype: '',
        woTypeId: null,
        floader: true,

        filePreData: {},

        mfileData: {},
        mloader: true,
        mfileStatus: '',
        failedFileData: [],
        upCount: 0,

        tokenExp: false,
        corpData: [],
        allcorpData: [],
        pendingData: [],
        allpendingData: [],
        entityTypes: [],
        woTypes: [],
        entityStatuses: [],

        invoiceData: {},
        ispinner: false,

        woBool: false,
        unauthorize: false,
        woAccess: true,
        allCompanies: [],
        acSpinner: false,
        checkwoData: null,

        invoicefileData: null,

        RCWVendorSpinner: false,
        RCWVesOwnerSpinner: false,
        vendorSharepointList: [],
        vesselOwnersSharePointList: [],
        billableVesPreQuatSpin: false,
        billableVesPreQuat: [],
        billedVesselSpin: false,
        billedVesselData: [],

        imoloader: false,
        imoData: [],

        imovloader: false,
        imoVesselData: {},

        imocloader: false,
        imoCompanyData: [],

        total: 0,
        counter: 0,
        progress: false,
        fileCount: 0,
        totalfilecount: [],

        fileStatus: '',
        fileExceed: false,

        bwloader: false,
        bwData: null,

        agloader: false,
        agData: null,

        agloaderBwo: false,
        agDataBwo: null,

        itloader: false,
        itData: null,

        validateCData: null,
        Comdet: null,
        pvSpinner: false,
        pvData: null,
        pspinner: false,
        allproductCodes: [],
        corporateSpinner: false,
        entityType: null,
        recordedStatusData: [],
        statusChecked: false
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getWorkOrderTypesAndCategories.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner1 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    const resData = action.payload.data
                    const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).isEmployee
                    const userData = JSON.parse(localStorage.getItem('userData'))
                    let woIdTypeData = []
                    let allAccess = true
                    if (userData) {
                        const userRoles = userData.userRoles
                        if (userRoles) {
                            const findRole = userRoles.find(find => (find.rId === 1 || find.rId === 3 || find.rId === 5))
                            if (findRole) {
                                state.enableAction = true
                            }
                            for (let i = 0; i < userRoles.length; i++) {
                                const role = userRoles[i]
                                if (role.rId === 1 || role.rId === 2 || role.rId === 3) {
                                    woIdTypeData = []
                                    allAccess = true
                                    break
                                } else {
                                    const wtId = role.wtId
                                    if (wtId) {
                                        if (!woIdTypeData.includes(wtId)) {
                                            woIdTypeData.push(wtId)
                                        }
                                    }
                                }
                            }
                        }
                    }

                    const woCatgs = []
                    if ((isEmployee) ? (woIdTypeData.length > 0 || allAccess) : true) {
                        resData.forEach((element) => {
                            const woTypesData = []
                            if (element.workorderTypes) {
                                element.workorderTypes.forEach((ele) => {
                                    if (isEmployee ? (allAccess ? true : (woIdTypeData.includes(ele.typeId))) : true) {
                                        woTypesData.push({ value: ele.typeId, label: ele.type, code: ele.typeCode, description: ele.description, disabled: false, isPublic: ele.isPublic })
                                    }
                                })
                            }
                            if (woTypesData.length > 0) {
                                woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData })
                            }
                        })
                    }

                    if (woCatgs.length > 0) {
                        state.woCates = woCatgs
                    } else {
                        state.woCates = []
                    }

                    state.woTypes = action.payload.data.flatMap(category => category.workorderTypes.map(type => ({
                            value: `${category.categoryCode}_${type.typeCode}`,
                            label: type.description
                        }))
                    )
                }
            })
            .addCase(getWorkorderStages.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner2 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woStages = action.payload.data
                }
            })
            .addCase(getAllCompanies.fulfilled, (state, action) => {
                if (action.payload) {
                    state.acSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allCompanies = action.payload.data
                }
            })
            .addCase(GetPartiesOfCurrentUser.fulfilled, (state, action) => {
                if (action.payload) {
                    state.acSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allCompanies = action.payload.data
                    state.unauthorize = action.payload.unauthorize
                }
            })
            .addCase(getCountryStates.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.countryStates = action.payload.data
                }
            })
            .addCase(getWorkorders.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            })
            .addCase(getWorkordersByFilters.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            })
            .addCase(getVesselDashboard.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            })
            .addCase(ValidateWorkorderCreation.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.checkwoData = action.payload.data
                }
            })
            .addCase(GetValidateClient.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.validateCData = action.payload.data
                }
            })
            .addCase(getBaseWorkorderData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.bwloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.bwData = action.payload.data
                }
            })
            .addCase(getWoLoading.fulfilled, (state) => {
                state.spinner3 = false
                state.entityTypes = []
                state.entityStatuses = []
                state.corpData = []
                state.allData = []
                state.data = []
                state.totalCount = 1
            })
            .addCase(getCommonDashboardData.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    const perPage = action.payload.perPage
                    const page = action.payload.page
                    const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
                    const arrayOfObjectsWithDates = action.payload.data.map(function (obj, index) {
                        obj.index = `${index + 1}`
                        obj.recordedDate = DateConversion(obj.recordedDate)
                        obj.isCompliant = obj.isCompliant ? 'Yes' : 'No'
                        return obj
                    })

                    const filterTypes = Array.from(new Set(arrayOfObjectsWithDates.map(x => x.type))).map(x => ({ value: x, label: x }))
                    const filterStatuses = Array.from(new Set(arrayOfObjectsWithDates.map(x => x.entityStatus))).map(x => ({ value: x, label: x }))
                    state.entityTypes = filterTypes
                    state.entityStatuses = filterStatuses
                    state.corpData = arrayOfObjectsWithDates
                    state.allData = arrayOfObjectsWithDates

                    const selectedDashWoTypeData = localStorage.getItem('selectedDashWoType')
                    if (selectedDashWoTypeData) {
                        state.allData = Array.from(new Set(state.allData)).filter(find => find.workorderType === selectedDashWoTypeData)
                    }

                    const sortname = 'corpName'
                    const sortorder = 'asc'
                    const sortData = sortorder ? sorting(sortname, sortorder, state.allData) : state.allData
                    state.data = paginateArray(sortData, perPage, page)
                    state.totalCount = sortData.length         
                    // if (action.payload.tab === 'tab0') {
                    //   state.allData = arrayOfObjectsWithDates.filter(find => find.entityStatus !== 'Recorded')
                    //   state.data = paginateArray(arrayOfObjectsWithDates.filter(find => find.entityStatus !== 'Recorded'), perPage, page)
                    //   state.totalCount = arrayOfObjectsWithDates.filter(find => find.entityStatus !== 'Recorded').length
                    // } else {
                    //   state.allData = arrayOfObjectsWithDates.filter(find => find.entityStatus === 'Recorded')
                    //   state.data = paginateArray(arrayOfObjectsWithDates.filter(find => find.entityStatus === 'Recorded'), perPage, page)
                    //   state.totalCount = arrayOfObjectsWithDates.filter(find => find.entityStatus === 'Recorded').length
                    // }
                    state.cdSpinner = true
                }
            })
            .addCase(GetCorporationsByEntityIdOrName.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    const perPage = action.payload.perPage
                    const page = action.payload.page
                    const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
                    const arrayOfObjectsWithDates = action.payload.data.map(function (obj, index) {
                        obj.index = `${index + 1}`
                        obj.recordedDate = DateConversion(obj.recordedDate)
                        obj.isCompliant = obj.isCompliant ? 'Yes' : 'No'
                        return obj
                    })
                    const filterTypes = Array.from(new Set(arrayOfObjectsWithDates.map(x => x.type))).map(x => ({ value: x, label: x }))
                    const filterStatuses = Array.from(new Set(arrayOfObjectsWithDates.map(x => x.entityStatus))).map(x => ({ value: x, label: x }))
                    state.entityTypes = filterTypes
                    state.entityStatuses = filterStatuses
                    state.corpData = arrayOfObjectsWithDates
                    state.allData = arrayOfObjectsWithDates
                    const sortname = 'corpName'
                    const sortorder = 'asc'
                    const sortData = sortorder ? sorting(sortname, sortorder, state.allData) : state.allData
                    state.data = paginateArray(sortData, perPage, page)
                    state.totalCount = sortData.length
                    state.cdSpinner = true
                }
            })
            .addCase(getData.fulfilled, (state, action) => {
                const perPage = action.payload.perPage
                const page = action.payload.page
                const sortname = action.payload.sortname
                const sortorder = action.payload.sortorder
                const searchId = action.payload.searchId
                const entityType = action.payload.entityType
                const entityStatus = action.payload.entityStatus
                const woType = action.payload.woType

                state.allData = state.corpData.filter(find => ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))

                if (entityType) {
                    state.allData = state.allData.filter(find => find.type === entityType)
                }
                if (entityStatus) {
                    state.allData = state.allData.filter(find => find.entityStatus === entityStatus)
                }
         
                if (woType) {
                    state.allData = state.allData.filter(find => find.workorderType === woType)
                }

                const sortData = sortorder ? sorting(sortname, sortorder, state.allData) : state.allData
                state.data = paginateArray(sortData, perPage, page)
                state.totalCount = sortData.length

                // if (action.payload.tab === 'tab0') {
                //   state.allData = state.corpData.filter(find => (find.entityStatus !== 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))
                //   const sortData = sortorder ? sorting(sortname, sortorder, state.corpData.filter(find => (find.entityStatus !== 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))) : state.corpData.filter(find => (find.entityStatus !== 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))
                //   state.data = paginateArray(sortData.filter(find => (find.entityStatus !== 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase())))), perPage, page)
                //   state.totalCount = state.corpData.filter(find => (find.entityStatus !== 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase())))).length
                // } else {
                //   state.allData = state.corpData.filter(find => (find.entityStatus === 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))
                //   const sortData = sortorder ? sorting(sortname, sortorder, state.corpData.filter(find => (find.entityStatus === 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))) : state.corpData.filter(find => (find.entityStatus === 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase()))))
                //   state.data = paginateArray(sortData.filter(find => (find.entityStatus === 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase())))), perPage, page)
                //   state.totalCount = state.corpData.filter(find => (find.entityStatus === 'Recorded') && ((find.corpId && String(find.corpId).toLowerCase().includes(searchId.toLowerCase())) || (find.corpName && String(find.corpName).toLowerCase().includes(searchId.toLowerCase())))).length
                // }
            })
            .addCase(getCorporationsByPartyId.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    state.allcorpData = action.payload.data.filter((item) => item.entityStatus !== 'InReview' && item.entityStatus !== 'Pending Approval')
                    state.corpData = action.payload.data.filter((item) => item.entityStatus !== "Recorded" && item.entityStatus !== 'InReview' && item.entityStatus !== 'Pending Approval')
                    state.corporateSpinner = true
                    state.recordedStatusData = action.payload.data.filter((item) => item.entityStatus === "Recorded")
                    state.entityType = Array.from(new Set(state.corpData.map(x => x.type)))[0]
                }
            })
            .addCase(AgentWorkorderEntities.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    state.allcorpData = action.payload.data.filter((item) => item.entityStatus !== 'InReview' && item.entityStatus !== 'Pending Approval')
                    state.corpData = action.payload.data.filter((item) => item.entityStatus !== 'InReview' && item.entityStatus !== 'Pending Approval')
                    state.pendingData = action.payload.data.filter((item) => item.entityStatus === 'Pending Approval')
                    state.allpendingData = action.payload.data.filter((item) => item.entityStatus === 'Pending Approval')
                    state.corporateSpinner = true
                    state.recordedStatusData = action.payload.data
                    state.entityType = Array.from(new Set(state.corpData.map(x => x.type)))[0]
                }
            })
            .addCase(getDocumentTemplateData.fulfilled, (state, action) => {
                if (action.payload) {
                    if (action.payload.reqData) {
                        if (action.payload.reqData.docType === 'Agr') {
                            state.agloader = action.payload.spinner
                            state.agData = action.payload.data
                        } else if (action.payload.reqData.docType === 'AgrBwo') {
                            state.agloaderBwo = action.payload.spinner
                            state.agDataBwo = action.payload.data
                        } else {
                            state.itloader = action.payload.spinner
                            state.itData = action.payload.data
                        }
                    }
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(getDocumentTemplateByCode.fulfilled, (state, action) => {
                if (action.payload) {
                    if (action.payload.reqData) {
                        if (action.payload.reqData.docType === 'Agr') {
                            state.agloader = action.payload.spinner
                            state.agData = action.payload.data
                        } else {
                            state.itloader = action.payload.spinner
                            state.itData = action.payload.data
                        }
                    }
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(CreateWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(getWorkordersData.fulfilled, (state, action) => {
                if (action.payload) {
                    if (action.payload.access) {
                        state.wloader = action.payload.spinner
                        state.tokenExp = action.payload.tokenExp
                        state.woIdData = action.payload.data
                        state.spinner4 = action.payload.spinner
                        state.woIData = action.payload.data1
                        if (action.payload.data) {
                            const payloadData = { ...action.payload.data }
                            if (payloadData) {
                                if (Array.from(new Set(payloadData?.application?.entities?.map(x => x.status))).length === 1) {
                                    state.statusChecked = true
                                }
                            }
                            if (payloadData) {
                                state.invoiceFileId = payloadData.invoiceFileId
                                state.autherizationFileId = payloadData.autherizationFileId
                            } else {
                                state.invoiceFileId = null
                                state.autherizationFileId = null
                            }
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                        state.uploadErrMsg = ''
                    } else {
                        state.woAccess = false
                    }
                }
            })
            .addCase(updateWoData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    // state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                }
            })
            .addCase(UpdateWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(RefreshWorkorderEntities.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                }
            })
            .addCase(UpdateIsNeedMoreInfo.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                    state.commentData = null
                }
            })
            .addCase(UpdateNeedMoreInfoStatus.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(CancelWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(getWorkordersById.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner4 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIData = action.payload.data
                }
            })
            .addCase(getNeedMoreInfoTracking.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.needMoreTracking = action.payload.data
                }
            })
            .addCase(downloadPDF.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.pdfData = action.payload.data
                }
            })
            .addCase(getInvoiceData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.ispinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.invoiceData = action.payload.data
                }
            })
            .addCase(getInvoiceFileData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.invoicefileData = action.payload.data
                }
            })
            .addCase(getWorkordersByIdComments.fulfilled, (state, action) => {
                state.spinnerComment = action.payload.spinner
                state.tokenExp = action.payload.tokenExp
                state.woIdComments = action.payload.data
            })
            .addCase(createWorkOrderComment.fulfilled, (state, action) => {
                const data = action.payload.data
                if (data?.status !== 'need') {
                    const woIdComments = state.woIdComments
                    woIdComments.push(action.payload.data)
                    state.spinnerComment = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdComments = woIdComments
                    state.needstatus = action.payload.needstatus
                    state.needcomment = action.payload.needcomment
                } else {
                    state.commentData = data
                }
            })
            .addCase(getFailedFileData.fulfilled, (state, action) => {
                if (action.payload) {
                    let failedFileData = [...state.failedFileData]
                    failedFileData.push({ filename: action.payload.filename, showFail: action.payload.showFail })
                    failedFileData = failedFileData.filter((item, index, self) => index === self.findIndex(obj => obj.filename === item.filename && obj.showFail === item.showFail))
                    state.failedFileData = failedFileData
                }
            })
            .addCase(closeProgressModal.fulfilled, (state, action) => {
                if (action.payload) {
                    state.failedFileData = []
                    state.progress = false
                    state.upCount = 0
                }
            })
            .addCase(saveFileUploads.fulfilled, (state, action) => {
                if (action.payload) {
                    state.upCount = state.upCount + 1
                    if (state.upCount === state.totalfilecount?.length) {
                        state.progress = true
                    }
                    if (!action.payload.type) {
                        state.floader = action.payload.spinner
                        state.tokenExp = action.payload.tokenExp
                        state.fileData = action.payload.data
                        state.woType = action.payload.woType
                        state.woTypeId = action.payload.woTypeId
                        state.stype = action.payload.stype
                    } else {
                        state.mloader = action.payload.spinner
                        state.tokenExp = action.payload.tokenExp
                        state.mfileData = action.payload.data
                    }
                } else {
                    state.upCount = state.upCount + 1
                    if (state.upCount === state.totalfilecount?.length) {
                        state.progress = true
                    }
                    state.mfileStatus = 'not count match'
                    if (action.payload) {
                        if (!action.payload.type) {
                            state.floader = true
                        } else {
                            state.mloader = true
                        }
                    } else {
                        state.fileExceed = true
                    }
                }
            })
            .addCase(getUpdateFileData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.total = action.payload.total
                    state.counter = action.payload.counter
                    state.progress = action.payload.progress
                    state.fileCount = action.payload.fileCount
                    state.totalfilecount = action.payload.totalfilecount
                    state.fileStatus = action.payload.fileStatus
                }
            })
            .addCase(removeWoFile.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(getWoFile.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.filePreData = action.payload.data
                }
            })
            .addCase(getWoAgreement.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.documentPreData = action.payload.data
                }
            })
            .addCase(getWoPreview.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.documentPreData = action.payload.data
                }
            })
            .addCase(saveMultipleFileUploads.fulfilled, (state, action) => {
                if (action.payload) {
                    state.mloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.mfileData = action.payload.data
                } else {
                    state.mloader = true
                }
            })
            .addCase(saveCSVRCWDocument.fulfilled, (state, action) => {
                if (action.payload) {
                    state.floader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.fileData = action.payload.data
                    state.woType = action.payload.woType
                    state.woTypeId = action.payload.woTypeId
                    state.stype = action.payload.stype
                    state.uploadErrMsg = action.payload.errorMsg
                } else {
                    state.floader = true
                }
            })
            .addCase(getStepNameStatus.fulfilled, (state) => {
                state.wdloader = false
                state.dloader = false
                // state.wloader = false
                state.cloader = false
                state.ispinner = false
            })
            .addCase(createWorkorder.fulfilled, (state, action) => {
                state.woBool = action.payload.boolean
            })
            .addCase(getClearMultiStatus.fulfilled, (state) => {
                state.mfileData = {}
                state.mfileStatus = ''
            })
            .addCase(getClearAppStatus.fulfilled, (state) => {
                state.corpData = []
                state.recordedStatusData = []
                state.entityType = ''
                state.corporateSpinner = false
            })
            .addCase(getClearStatus.fulfilled, (state) => {
                state.wdloader = false
                state.dloader = false
                state.wloader = false
                state.cloader = false
                state.ispinner = false
                state.woIData = null
                state.spinner3 = false
                state.bwloader = false
                state.bwData = null
                state.agloader = false
                state.agData = null
                state.agloaderBwo = false
                state.agDataBwo = null
                state.itloader = false
                state.itData = null
                state.imoData = []
                state.imoloader = false
                state.invoicefileData = null
            })
            .addCase(getClearPaymentStatus.fulfilled, (state) => {
                state.billedVesselSpin = false
                state.wloader = false
                state.ispinner = false
                state.spinner4 = false
                state.woIData = null
                state.woIdData = []
            })
            .addCase(getClearStore.fulfilled, (state) => {
                state.woIdData = []
                state.woIData = null
                state.checkwoData = null
            })
            .addCase(getClearStoreData.fulfilled, (state) => {
                state.checkwoData = null
                state.allcorpData = []
            })
            .addCase(getClearFileData.fulfilled, (state) => {
                state.fileData = {}
                state.floader = true
            })
            .addCase(removeneedinfodata.fulfilled, (state) => {
                state.needcomment = ''
                state.needstatus = ''
            })
            .addCase(getFileExceed.fulfilled, (state) => {
                state.fileExceed = false
            })
            .addCase(getVendorsSharePointList.fulfilled, (state, action) => {
                if (action.payload) {
                    state.billableVesPreQuatSpin = false
                    state.billedVesselSpin = false

                    state.billableVesPreQuat = []
                    state.billedVesselData = []

                    state.RCWVendorSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.vendorSharepointList = action.payload.data
                }
            })
            .addCase(getVesselOwnersSharePointList.fulfilled, (state, action) => {
                if (action.payload) {
                    state.billableVesPreQuatSpin = false
                    state.billedVesselSpin = false

                    state.billableVesPreQuat = []
                    state.billedVesselData = []

                    state.RCWVesOwnerSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.vesselOwnersSharePointList = action.payload.data
                }
            })
            .addCase(getBillableVesselsForPreviousQuarter.fulfilled, (state, action) => {
                if (action.payload) {
                    state.RCWVendorSpinner = false
                    state.RCWVesOwnerSpinner = false
                    state.billedVesselSpin = false

                    state.vendorSharepointList = []
                    state.vesselOwnersSharePointList = []
                    state.billedVesselData = []

                    state.billableVesPreQuatSpin = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.billableVesPreQuat = action.payload.data
                }
            })
            .addCase(getERBPCListByIMONumber.fulfilled, (state, action) => {
                if (action.payload) {
                    state.erbCListSpin = false
                    state.erbCListSpin = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.erbCList = action.payload.data
                }
            })
            .addCase(getUpdatedBillableVoyAges.fulfilled, (state, action) => {
                if (action.payload) {
                    state.RCWVendorSpinner = false
                    state.billableVesPreQuatSpin = false
                    state.billableVesPreQuatSpin = false

                    state.vendorSharepointList = []
                    state.vesselOwnersSharePointList = []
                    state.billableVesPreQuat = []

                    state.billedVesselSpin = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.billedVesselData = action.payload.data
                }
            })
            .addCase(getIMONumbers.fulfilled, (state, action) => {
                if (action.payload) {
                    state.imoloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.imoData = action.payload.data
                }
            })
            .addCase(getVesselByImoNumber.fulfilled, (state, action) => {
                if (action.payload) {
                    state.imovloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.imoVesselData = action.payload.data
                    state.imoCompanyData = action.payload.companysData
                }
            })
            .addCase(GetCompanyAddressdetails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Comdet = action.payload.data
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(GetERBRAVersionChecking.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.pvSpinner = action.payload.spinner
                    state.pvData = action.payload.data
                }
            })
            .addCase(getAllProductCodes.fulfilled, (state, action) => {
                if (action.payload) {
                    state.pspinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allproductCodes = action.payload.data
                }
            })
    }
})
export default commonreducerSlice.reducer
